export default __webpack_public_path__ + "static/media/car3.ea296824.jpg";